<template>
  <div id="app">
    <MainNavBar></MainNavBar>
    <router-view />
    <BusyIndicator></BusyIndicator>
  </div>
</template>

<style>
</style>

<script>
import MainNavBar from "./components/MainNavBar.vue";
import BusyIndicator from "./components/BusyIndicator.vue";

export default {
  components: {
    MainNavBar,
    BusyIndicator
  },
  created() {
    this.$store.dispatch("settings/initialize");
    window.addEventListener("storage", this.onSettingsUpdated);
  },
  beforeDestroy() {
    window.removeEventListener("storage", this.onSettingsUpdated);
  },
  errorCaptured(err, vm, info) {
    return this.$store.dispatch("notification/logerror", {
      err: err,
      vm: vm,
      info: info
    });
  },
  methods: {
    onSettingsUpdated(event) {
      this.$store.dispatch("settings/parseStorageEvent", event);
    }
  }
};
</script>